import { animate, scroll } from "motion";

document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".header");
    const headerLogo = header.querySelector(".header__logo");
    const headerButtons = header.querySelector(".header__buttons");
    const menuButton = header.querySelector(".header__menu-button");
    scroll(
        animate([headerLogo, headerButtons], {
            y: [0, -(header.offsetTop + header.offsetHeight)],
        }),
        {
            target: header,
            offset: ["start 24px", "end start"],
        }
    );

    const handleMenuToggle = async () => {
        header.classList.toggle("header--open");
        const label = menuButton.querySelector("span");
        const icon = menuButton.querySelector("svg > path");
        const d = header.classList.contains("header--open")
            ? icon.getAttribute("data-path-close")
            : icon.getAttribute("data-path-open");

        await animate(icon, {
            d,
            duration: 640,
            ease: "easeInOut",
        });

        label.innerHTML = header.classList.contains("header--open")
            ? label.getAttribute("data-label-close")
            : label.getAttribute("data-label-open");
    };

    menuButton.addEventListener("click", handleMenuToggle);

    const mediaQuery = window.matchMedia("(max-width: 1024px)");
    const handleMatchMediaChange = (e) => {
        if (!e.matches && header.classList.contains("header--open")) {
            handleMenuToggle();
        }
    };

    mediaQuery.addEventListener("change", handleMatchMediaChange);

    handleMatchMediaChange(mediaQuery);

    // Track whether a hash-driven section is active
    let hasActiveHash = !!window.location.hash;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                // Only highlight sections when a hash is active
                if (!hasActiveHash) return;
                const id = entry.target.getAttribute("id");

                links.forEach((link) => {
                    const url = new URL(link.getAttribute("href"), window.location.origin);
                    // Only consider links pointing to this same page
                    if (url.pathname !== window.location.pathname) return;

                    link.removeAttribute("aria-current");
                    if (url.hash === "#" + id) {
                        link.setAttribute("aria-current", "location");
                    }
                });
            });
        },
        {
            root: null,
            rootMargin: "200px",
            threshold: 0.1,
        }
    );

    const links = header.querySelectorAll('.header__nav a[href*="#"]:not([href="#"])');

    links.forEach((link) => {
        const url = new URL(link.getAttribute("href"), window.location.origin);
        const isSamePage = url.pathname === window.location.pathname;
        const section = isSamePage ? document.querySelector(url.hash) : null;

        if (isSamePage && section) {
            observer.observe(section);

            // Initial highlight on load (e.g. landing on /#news)
            if (url.hash === window.location.hash) {
                link.setAttribute("aria-current", "location");
                hasActiveHash = true;
            }

            link.addEventListener("click", function (e) {
                e.preventDefault();
                if (header.classList.contains("header--open")) {
                    handleMenuToggle();
                }
                section.scrollIntoView({ behavior: "smooth" });

                links.forEach((l) => l.removeAttribute("aria-current"));
                link.setAttribute("aria-current", "location");

                history.pushState(null, "", url.hash);
                hasActiveHash = true;
            });
        }
    });

    // Handle homepage link(s): same page path and no hash -> scroll to top and clear section highlights
    const allNavLinks = header.querySelectorAll(".header__nav a");
    allNavLinks.forEach((link) => {
        const url = new URL(link.getAttribute("href"), window.location.origin);
        const isSamePageHome = url.pathname === window.location.pathname && !url.hash;
        if (!isSamePageHome) return;

        link.addEventListener("click", function (e) {
            // If navigating to the same path without hash, prevent reload and handle smoothly
            e.preventDefault();
            if (header.classList.contains("header--open")) {
                handleMenuToggle();
            }
            window.scrollTo({ top: 0, behavior: "smooth" });

            // Clear any section highlight
            links.forEach((l) => l.removeAttribute("aria-current"));

            // Ensure URL has no hash
            if (window.location.hash) {
                history.pushState(null, "", url.pathname);
            }
            hasActiveHash = false;
        });
    });

    // On initial load without hash, ensure no section link is highlighted
    if (!window.location.hash) {
        links.forEach((l) => l.removeAttribute("aria-current"));
        hasActiveHash = false;
    }

    // Keep state in sync when navigating back/forward between hash and no-hash states
    window.addEventListener("popstate", () => {
        hasActiveHash = !!window.location.hash;
        if (!hasActiveHash) {
            links.forEach((l) => l.removeAttribute("aria-current"));
        } else {
            links.forEach((l) => l.removeAttribute("aria-current"));
            const currentLink = Array.from(links).find((l) => {
                const u = new URL(l.getAttribute("href"), window.location.origin);
                return u.pathname === window.location.pathname && u.hash === window.location.hash;
            });
            if (currentLink) currentLink.setAttribute("aria-current", "location");
        }
    });
});
